// Central session object that handles login/logout without reloading page
//
// All elements with classes logged-in/logged-out will be shown/hidden automatically
//
// Example callback:
// $(session).on('login logout', function(e, session) { console.log(session.authenticated); });
//
// login / logout is not called onload, so use session.authenticated to setup onload conditions
define('all/player/session',['module', 'jquery'], function(module, $) {
	'use strict';

	var session = {};

	session.authenticated = module.config().authenticated;

	function getRootDomain(){
		return location.href.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].replace('www.','');
	}

	function login() {
		session.authenticated = true;
		$(session).triggerHandler('login', session);

		// trigger the google tag manager to fire tracking pixels
		$.post('/pp?flow=TriggerLoginPixelTracking', {}, function (pixelTrackingData) {
			$('#login-tracking-pixel').html(pixelTrackingData);
		});

		showHideStandardClasses();
		setupHelpCenter();
	}

	function logout() {
		session.authenticated = false;
		var domain = getRootDomain();
		$.removeCookie('sessionId', {domain: domain, path: '/'});
		$(session).triggerHandler('logout', session);
		showHideStandardClasses();
		setupHelpCenter()
	}

	function showHideStandardClasses() {
		var $inlineLoggedIn = $('.ui-button.logged-in');
		var $inlineLoggedOut = $('.ui-button.logged-out');
		if(session.authenticated) {
			$inlineLoggedIn.css('display','inline-block');
			$inlineLoggedOut.css('display', 'none');
		} else {
			$inlineLoggedOut.css('display','inline-block');
			$inlineLoggedIn.css('display', 'none');
		}
		$('.logged-in').not('.ui-button').toggle(session.authenticated);
		$('.logged-out').not('.ui-button').toggle(!session.authenticated);
	}

	function setupHelpCenter() {
		if (window.helpCenter) {
			if (session.authenticated) {
				window.helpCenter.set({
					contact: {
						firstName: window.playerinfo.info.firstname || '',
						lastName: window.playerinfo.info.lastname || '',
						username: window.playerinfo.info.username || '',
						email: window.playerinfo.info.email || '',
						phone: window.playerinfo.info.mobile || '',
						// hidden fields
						comeonSegment: window.playerinfo.info.valueSegmentCurrent || '',
						comeonHighestSegment: window.playerinfo.info.valueSegmentHighest || '',
						comeonSharedValue: window.playerinfo.info.allBrandsValueSegmentHighest || ''
					}
				});
			} else {
				window.helpCenter.set({
					contact: {}
				});
			}
		}
	}

	session.login = login;
	session.logout = logout;
	session.showHideStandardClasses = showHideStandardClasses;

	return session;
});

